import React from 'react';
import classNames from 'classnames';

function OverviewWarningMessagesViewTemplate ({ modelAttributes, helpers }) {

	const { displayableWarnings } = modelAttributes;

	const { warnings } = helpers;
	const className = classNames(
		'cartOverviewWarning',
		'cartWarningMessage',
		(!displayableWarnings || displayableWarnings.length === 0) && 'hidden'
	);

	return (
		<>
			{warnings
				&& warnings.map((warning, i) => (
					<React.Fragment key={`warning-${i}`}>
						<div className={className}>
							{warning}
						</div>
					</React.Fragment>
				))}
		</>
	);

}

export default OverviewWarningMessagesViewTemplate;
